export default __webpack_public_path__ + "static/media/header-img.6e81e31a.png";